import * as z from 'zod';
import { TFunction } from 'next-i18next';

import { MAX_POST_TITLE_LENGTH } from 'utils/constants';
import { PostAttachmentType } from '__generated__/graphql/legacy/graphql';

const attachment = z.object({
  altText: z.string().optional().nullable(),
  attachmentType: z.nativeEnum(PostAttachmentType),
  attachmentUrl: z.string().optional().nullable(),
  fileName: z.string().optional().nullable(),
  fileSizeInBytes: z.number().optional().nullable(),
  filestackId: z.string().optional(),
  id: z.string().optional(),
  isLoading: z.boolean().optional(),
  s3Bucket: z.string().optional(),
  s3Key: z.string().optional(),
  tempId: z.string().optional(),
  url: z.string().optional().nullable(),
});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getAttachmentSchema = () => {
  return attachment;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getSchema = (tFunc?: TFunction) => {
  const t = tFunc || ((s) => s); // Needed for custom messages
  return z.object({
    title: z
      .string()
      .max(MAX_POST_TITLE_LENGTH)
      .refine((val) => val?.trim(), {
        message: t(
          'Title must have at least one character other than blank space.'
        ),
      }),
    content: z.string().default(''),
    spaceId: z.string().refine((val) => !!val, {
      message: t('Please select a valid space.'),
    }),
    attachments: z.array(attachment),
    mentionedUserIds: z.array(z.string()).optional(),
  });
};
